import { z } from 'zod';

const TIME_REGEX = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;

const timeBlockSchema = z
  .object({
    startTime: z.string().min(1, 'Godzina rozpoczęcia jest wymagana').regex(TIME_REGEX, 'Nieprawidłowy format godziny'),
    endTime: z.string().min(1, 'Godzina zakończenia jest wymagana').regex(TIME_REGEX, 'Nieprawidłowy format godziny'),
  })
  .refine(
    (data) => {
      const startParts = data.startTime.split(':').map(Number);
      const endParts = data.endTime.split(':').map(Number);
      const startMinutes = (startParts[0] ?? 0) * 60 + (startParts[1] ?? 0);
      const endMinutes = (endParts[0] ?? 0) * 60 + (endParts[1] ?? 0);
      return endMinutes - startMinutes >= 30;
    },
    { message: 'Blok musi trwać co najmniej 30 minut', path: ['endTime'] }
  );

const scheduleDaySchema = z.object({
  dayOfWeek: z.number().min(0).max(6),
  blocks: z.array(timeBlockSchema).min(1, 'Dodaj co najmniej jeden blok czasowy'),
});

export const scheduleSchema = z
  .object({
    validFrom: z.string().min(1, 'Data rozpoczęcia jest wymagana'),
    validTo: z.string().min(1, 'Data zakończenia jest wymagana'),
    days: z.array(scheduleDaySchema).min(1, 'Wybierz co najmniej jeden dzień tygodnia'),
    serviceIds: z.array(z.string()).min(1, 'Wybierz co najmniej jedną usługę'),
  })
  .refine(
    (data) => {
      if (!data.validFrom || !data.validTo) return true;
      return data.validFrom <= data.validTo;
    },
    { message: 'Data zakończenia musi być po dacie rozpoczęcia', path: ['validTo'] }
  )
  .refine(
    (data) => {
      if (!data.validTo) return true;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const to = new Date(data.validTo);
      to.setHours(0, 0, 0, 0);
      const diffDays = Math.round((to.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
      return diffDays <= 60;
    },
    { message: 'Grafik nie może sięgać dalej niż 60 dni od dzisiaj', path: ['validTo'] }
  );

export type ScheduleFormData = z.infer<typeof scheduleSchema>;
export type ScheduleDayFormData = z.infer<typeof scheduleDaySchema>;
export type TimeBlockFormData = z.infer<typeof timeBlockSchema>;
